var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"white--text"},[_c('h1',[_vm._v("Error")]),_c('p',[_vm._v("An error occurred while processing the request.")]),_c('pre',[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }